import Vue from 'vue'

import notyf from '@/config/notyf'
Vue.use(notyf)

import VueSvgIcon from 'vue-svgicon'

Vue.use(VueSvgIcon, {
  tagName: 'icon',
})

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
